<template>
  <el-container>
    <el-aside
      width="200px"
      :class="collapsed ? 'menu-collapsed' : 'menu-expanded'"
    >
      <div
        class="lh60 h60 f18 center colorfff"
        style="background: var(--sidebar-bg); color: var(--header-text)"
      >
        {{ collapsed ? "" : sysName }}
      </div>
      <div class="menu">
        <!--导航菜单-->
        <el-menu
          :default-active="$route.path"
          router
          class="el-menu-vertical-demo"
          text-color="#fff"
          active-text-color="#409EFF"
          @open="handleOpen"
          @close="handleClose"
          :collapse="collapsed"
        >
          <sidebar-menu-item
            v-for="(item, index) in menu"
            :key="
              item && item.menuId !== undefined
                ? 'menu-' + item.menuId
                : 'menu-index-' + index
            "
            :item="item"
          />
          <!-- <el-menu-item index="2">
                        <i class="el-icon-menu"></i>
                        <span slot="title">导航二</span>
                    </el-menu-item>
                    <el-menu-item index="3" disabled>
                        <i class="el-icon-document"></i>
                        <span slot="title">导航三</span>
                    </el-menu-item>
                    <el-menu-item index="4">
                        <i class="el-icon-setting"></i>
                        <span slot="title">导航四</span>
                    </el-menu-item> -->
        </el-menu>
      </div>
    </el-aside>
    <el-container>
      <el-header class="pdl-0">
        <el-row>
          <el-col :span="1" class="center">
            <div class="tools" @click.prevent="collapse">
              <i
                class="colorfff"
                :class="collapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
              ></i>
            </div>
          </el-col>
          <el-col
            :span="4"
            class="colorfff f18 lh60 h60"
            v-overflow-tooltip
          >
            <div>{{ companyName }}</div>
          </el-col>
          <el-col :span="19">
            <div class="flex-between">
              <span class="colorfff font22">{{ warehouse.opName || "" }}</span>
              <div class="flex-center flex aic">
                <!-- 服务切换框 -->
                <div class="mgr-30" v-if="serveArr.length > 1">
                  <span class="color1989fa fw-600 mgr-10">设备类型</span>
                  <el-select
                    @change="changeFuwu"
                    v-model="serve"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in serveArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!--  -->
                <div @click="toMsg">
                  <el-badge
                    @click="toMsg"
                    v-if="msg != 0"
                    :value="msg"
                    :max="99"
                    class="item mgr-20"
                  >
                    <i class="font20 colorfff el-icon-bell cursor"></i>
                  </el-badge>
                  <i
                    v-else
                    class="font20 mgr-20 colorfff el-icon-bell cursor"
                    @click="toMsg"
                  ></i>
                </div>
                <!-- 日/夜切换：置于 toMsg 容器之外，避免点击冒泡跳转消息中心 -->
                <theme-toggle class="mgr-20"></theme-toggle>
                <span @click="toMsg" class="colorfff mgr-20" v-if="nowTime">{{
                  nowTime
                }}</span>

                <el-dropdown trigger="hover">
                  <div class="flex-center">
                    <el-avatar
                      :size="40"
                      :src="sysUserAvatar"
                      class="tupian"
                    ></el-avatar>
                    <div
                      class="flex-center-c mgl-10"
                      style="
                        color: var(--header-text);
                        justify-content: center;
                        height: 60px;
                      "
                    >
                      <div class="line1">欢迎您！</div>
                      <div class="line1">{{ sysUserName }}</div>
                    </div>
                  </div>

                  <el-dropdown-menu slot="dropdown">
                    <!-- <el-dropdown-item></el-dropdown-item> -->
                    <el-dropdown-item @click.native="gotoPersonal"
                      >个人中心</el-dropdown-item
                    >
                    <el-dropdown-item divided @click.native="gotoCode"
                      >忘记密码</el-dropdown-item
                    >
                    <el-dropdown-item divided @click.native="logout"
                      >退出登录</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="sceneInfo.length !== 1"
                      divided
                      @click.native="sceneSelect"
                      >场景切换</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <div class="bg-e2e2e2">
          <!-- 公共消息弹框提醒 -->
          <div class="LayoutDio">
            <el-dialog
              title="消息提醒"
              :visible.sync="dialogVisible"
              width="20%"
              center
              top="30vh"
              :close-on-click-modal="false"
              :modal="false"
            >
              <div class="fw-600 f18">{{ noticeTitle }}</div>
              <div class="mgt-10">{{ noticeText }}</div>
              <div class="mgt-10">{{ sendTime }}</div>
              <span slot="footer" class="dialog-footer">
                <el-button class="mgr-30" @click="ignore"
                  >忽略 {{ daojishi }}s</el-button
                >
                <el-button type="primary" @click="handleLookNewMsg"
                  >查 看</el-button
                >
              </span>
            </el-dialog>
          </div>
          <!--  -->
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </el-main>
      <!-- <el-footer class="center lh45"
                 height="45">Footer
      </el-footer> -->
    </el-container>
  </el-container>
</template>

<script>
// import headimg from '../img/1112.png'
import EventBus from "../utils/EventBus";

import { menulist } from "../api/system";
import store from "../store";
import request from "../utils/fetch";
import {
  roUrlTest,
  roUrlFormal,
  lyjUrlTest,
  lyjUrlFormal,
  lrwUrlTest,
  lrwUrlFormal,
  zysUrlTest,
  zysUrlFormal
} from "../utils/serverUrl";
import {
  getProtocol,
  resolveServiceUrl,
  buildSwitchUrl,
} from "../utils/serviceSwitch";
import { cacheRouterPath } from "@/utils/UtilsIf";
import ThemeToggle from "../components/ThemeToggle.vue";
import SidebarMenuItem from "../components/SidebarMenuItem.vue";
import { getFirstNavigablePath } from "../utils/treeUtils";
export default {
  components: { ThemeToggle, SidebarMenuItem },
  data() {
    return {
      btns: [],
      sysName: "云术企业后台管理系统",
      // sysName: "云术智慧水订单管理系统",
      path: cacheRouterPath.get(),
      collapsed: false,
      sysUserName: "",
      sysUserAvatar: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      info: {
        nickName: ""
      },
      warehouse: "",
      msg: "",
      photo: require("../img/dd1.png"),
      nowTime: "",
      sceneInfo: [],
      serveArr: [],
      serve: "",
      // 新消息提醒
      dialogVisible: false,
      shownIds: new Set(), // 用于存储已显示的 ID
      intervalId: null, // 用于保存定时器ID
      currentDialog: null, // 当前弹框的信息
      noticeText: "",
      noticeTitle: "",
      sendTime: "",
      daojishi: 10,
      daojishiTimer: null,
      companyld:null,
      companyName:'',

      // ro网站
      roUrlTest,
      roUrlFormal,
      // 楼宇机网站
      lyjUrlTest,
      lyjUrlFormal,
      // 冷热温网站
      lrwUrlTest,
      lrwUrlFormal,
      // 直饮水网站
      zysUrlTest,
      zysUrlFormal
    };
  },
  computed: {
    menu() {
      return Array.isArray(this.$store.state.menu) ? this.$store.state.menu : [];
    }
  },
  created() {
    this.info = this.$store.getters.get_token;


    // 获取vuex中 的 token 信息
    this.companyld = this.$store.getters.get_token.companyId;
    console.log('公司信息：',this.companyld)

    if(this.companyld){
      this.getCompanyById()
    }


    this.show();

    // this.getHouseInfo();
    this.getServer();
    this.getMessageCount();
    this.getInfo();
    this.getList();
    EventBus.$on("share", value => {
      this.sysUserAvatar = value;
    });
    EventBus.$on("name", value => {
      this.sysUserName = value;
    });
    EventBus.$on("none", value => {
      this.msg = value;
    });
    this.getROLE();
    // this.startListening(); // 开始监听数据  新消息通知
  },
  watch: {
    $route: {
      handler: function(v) {
        cacheRouterPath.set(v.path);
      }
    }
  },

  beforeDestroy() {
    clearInterval(this.intervalId); // 组件销毁时清除定时器
    clearInterval(this.daojishiTimer); // 组件销毁时清除定时器
  },
  methods: {
    // 获取公司名称
    getCompanyById(){
      // this.$api.system.getCompanyName({companyId:this.companyld}).then(res=>{
      //   console.log('获取公司名称',res)
      //   if(res.code==200){
      //     this.companyName = res.data.companyName

      //   }
      // })
    
    },
    // 字典表
    getShebeiType() {
      this.$api.dict.list({ dictName: "服务管理" }).then(res => {
        if (res.code === 200) {
          this.serveArr = [];
          res.data.forEach(v => {
            if (v.dictPid !== 0) {
              this.serveArr.push({
                name: v.dictName,
                id: v.dictValue
              });
            }
          });
          this.serve = "1";
        }
      });
    },
    getServer() {
      this.$api.home.serverHttp().then(res => {
        if (res.code === 200) {
          let serverArr = res.data;

          // 等待 getFuwu 函数的结果，并更新 serverArr
          this.getFuwu(serverArr).then(updatedServerArr => {
            this.serveArr = updatedServerArr;
            this.serve = "1";
            // if (store.getters.get_sceneId == 3) {
            //   // 如果 sceneId 等于 3，过滤掉 id=4 的对象
            //   this.serveArr = this.serveArr.filter((item) => item.id !== "4");
            // } else if (store.getters.get_sceneId == 1) {
            //   console.log("sceneId 等于1");

            //   // 如果 sceneId 等于 1，只保留 id=4 的对象
            //   this.serveArr = this.serveArr.filter((item) => item.id === "4");

            // }
          });
        }
      });
    },
    getFuwu(n) {
      // 返回一个 Promise
      return new Promise((resolve, reject) => {
        this.$api.dict
          .list({ dictName: "服务管理" })
          .then(res => {
            if (res.code === 200) {
              let arr = n.map(itemA => {
                // 在 B 数组中查找匹配的项
                let matchedItemB = res.data.find(
                  itemB => itemB.dictValue === itemA.id
                );

                // 如果找到匹配项，更新 itemA 的 name 字段
                if (matchedItemB) {
                  itemA.name = matchedItemB.dictName;
                }

                return itemA;
              });

              // 解析 Promise，返回更新后的数组
              resolve(arr);
            } else {
              // 如果请求失败，拒绝 Promise
              reject(new Error("Failed to fetch dictionary list."));
            }
          })
          .catch(error => {
            // 捕获并处理任何网络错误或其他异常
            reject(error);
          });
      });
    },
    // 改变服务端（切换到其它服务，携带登录态跳转）
    changeFuwu(e) {
      // 服务 id → { 测试服地址, 正式服地址 }；当前服务(id=1/售水机)不在表中，选择后不跳转
      const serviceUrlMap = {
        2: { test: this.lyjUrlTest, formal: this.lyjUrlFormal }, // 楼宇机
        3: { test: this.roUrlTest, formal: this.roUrlFormal }, // ro
        4: { test: this.lrwUrlTest, formal: this.lrwUrlFormal }, // 冷热温
        5: { test: this.zysUrlTest, formal: this.zysUrlFormal } // 直饮水
      };

      // 按当前请求协议解析目标基础地址：http→测试服 / https→正式服
      const baseUrl = resolveServiceUrl(
        serviceUrlMap[e],
        getProtocol(request.defaults.baseURL)
      );
      if (!baseUrl) return; // 选中当前服务、未配置地址或协议异常时不跳转

      // 拼接携带登录态的跳转地址
      const externalUrl = buildSwitchUrl(
        store.getters.get_token,
        window.sessionStorage["sceneId"],
        window.sessionStorage["sceneName"],
        baseUrl
      );

      // 清空本地登录态后跳转到目标服务
      this.resetDynamicRoutes();
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      this.$store.dispatch("set_user", "");
      this.$store.dispatch("set_token", "");
      this.$store.dispatch("set_menu", "");
      sessionStorage.clear();
      this.$route.meta.btns = [];
      window.location.href = externalUrl; // 跳转
    },

    ignore() {
      this.dialogVisible = false;
      clearInterval(this.daojishiTimer);
    },
    handleLookNewMsg() {
      this.dialogVisible = false;
      this.$router.push("/sys/news");
    },
    // 新消息通知
    startListening() {
      this.intervalId = setInterval(this.fetchData, 10000); // 每 10 秒调用一次 fetchData
    },
    fetchData() {
      this.$api.message.newMsg().then(res => {
        if (res.code === 200) {
          // 假设 res.data 是一个数组，每个数组项都有一个 id 字段

          if (!this.shownIds.has(res.data.id)) {
            // 如果 ID 没有被显示过，则弹框
            this.noticeText = res.data.noticeText;
            this.noticeTitle = res.data.noticeTitle;
            this.sendTime = res.data.sendTime;

            this.dialogVisible = true; // 显示弹框
            this.daojishi = 10;
            this.daojishiTimer = setInterval(() => {
              this.daojishi--;
              if (this.daojishi == 0) {
                this.dialogVisible = false;
                clearInterval(this.daojishiTimer);
              }
            }, 1000);
            this.currentDialog = res.data; // 记录当前弹框的数据
            this.shownIds.add(res.data.id); // 记录此 ID 已被弹框
          }
        }
      });
      // 假设 res.data 是一个数组，每个数组项都有一个 id 字段
      // res.data.forEach(item => {
      //   if (!this.shownIds.has(item.id)) {
      //     // 如果 ID 没有被显示过，则弹框
      //     this.dialogMessage = `有新数据: ${JSON.stringify(item)}`; // 设置弹框消息
      //     this.dialogVisible = true; // 显示弹框
      //     this.currentDialog = item; // 记录当前弹框的数据
      //     this.shownIds.add(item.id); // 记录此 ID 已被弹框
      //   }
      // });
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.sceneInfo = token.sceneInfo;
      }
    },
    getInfo() {
      this.$api.admincustomerq.gainCustomerInfo().then(res => {
        if (res.code === 200) {
          this.info = res.data;
        }
      });
    },

    toMsg() {
      // this.$router.push("/managementhrough/meandxiao");
      this.$router.push("/sys/news");
    },
    gotoCode() {
      this.resetDynamicRoutes();
      this.$store.dispatch("set_token", "");
      this.$router.push("/getCode");
    },
    getSelectOptions() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      console.log(user.roleList);
    },
    getList() {
      this.$api.admincustomerq.getcustomerinfo1().then(d => {
        if (d.code == 200) {
          // console.log('成功');
          if (d.data.customerFace == null) {
            this.sysUserAvatar = require("../img/dd1.png");
          } else {
            this.sysUserAvatar = d.data.customerFace;
          }
          if (d.data.customerName == null) {
            d.data.customerName = "企业用户";
          } else {
            this.sysUserName = d.data.customerName;
          }
          if (d.data.customerPhone == null) {
            d.data.customerPhone = "无";
          }
          // this.info = d.data;
        }
      });
    },
    //所属详情
    // getHouseInfo() {
    //   this.$api.admincustomerq
    //     .getOperateInfo()
    //     .then((d) => {
    //       console.log('获取所属',d)
    //       this.warehouse = d.data[0];

    //       sessionStorage.setItem("opId", this.warehouse.opId);
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
    // },
    //消息未读总条数
    getMessageCount() {
      this.$api.system
        .msgNum({ isRead: false })
        .then(d => {
          if (d.code === 200) {
            this.msg = d.data;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },

    gotoPersonal() {
      this.$router.push("/personage/detail");
    },
    show() {
      // 仅根路径跳转到首个可访问页面，避免深链接及其 query/hash 被覆盖。
      if (this.$route.path !== "/" && this.$route.path !== "/index") return;

      const firstPath = getFirstNavigablePath(this.menu);
      if (firstPath) {
        this.$router.replace({
          path: firstPath,
          query: this.$route.query,
          hash: this.$route.hash
        });
      }
    },
    resetDynamicRoutes() {
      if (typeof this.$router.resetDynamicRoutes === "function") {
        this.$router.resetDynamicRoutes();
      }
    },
    initBtn(btns) {},
    onSubmit() {
      console.log("submit!");
    },
    handleOpen() {
      //console.log('handleopen');
    },
    sceneSelect() {
      this.resetDynamicRoutes();
      this.$store.dispatch("set_menu", "");
      this.$route.meta.btns = [];
      sessionStorage.removeItem("user");
      this.$store.dispatch("set_user", "");
      this.$router.push("/sceneSelect");
    },
    handleClose() {
      //console.log('handleclose');
    },
    handleSelect: function(a, b) {},
    //退出登录
    logout() {
      //   this.$confirm("确认退出吗?", "提示", { type: "warning" })
      //     .then(() => {
      //       this.$api.admincustomer
      //         .customerlogout({})
      //         .then((d) => {
      //           if (d.code == 200) {
      //             sessionStorage.removeItem("token");
      //             sessionStorage.removeItem("user");
      //             this.$store.dispatch("set_user", "");
      //             this.$store.dispatch("set_token", "");
      //             this.$store.dispatch("set_menu", "");
      //             console.log(this.$store.state);
      //             sessionStorage.clear();
      //             // this.$route.meta.btns
      //             this.$route.meta.btns = [];
      //             this.$router.push("/Login");
      //           } else {
      //             this.$message.error(d.msg);
      //           }
      //         })
      //         .catch((e) => {
      //           console.log(e);
      //         });
      //     })
      //     .catch(() => {});
      // },
      // defaultBtns(btns) {
      //   console.log("btns", btns);
      this.resetDynamicRoutes();
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      this.$store.dispatch("set_user", "");
      this.$store.dispatch("set_token", "");
      this.$store.dispatch("set_menu", "");
      sessionStorage.clear();
      this.$route.meta.btns = [];
      // 获取当前 URL
      const currentUrl = window.location.href;

      // 创建一个新的 URL 对象
      const url = new URL(currentUrl);

      // 清空查询参数
      url.search = "";

      // 使用 replaceState 修改当前 URL
      window.history.replaceState({}, "", url.toString());
      this.$router.push("/Login");
    },
    //折叠导航栏
    collapse: function() {
      this.collapsed = !this.collapsed;
    },
    nowTimes() {
      this.timeFormate(new Date());
      setInterval(this.nowTimes, 60000);
      this.clear();
    }, //显示当前时间（年月日时分秒）
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let week = new Date(timeStamp).getDay();
      let weeks = ["日", "一", "二", "三", "四", "五", "六"];
      let getWeek = "星期" + weeks[week];
      this.nowTime = year + "年" + month + "月" + date + "日" + " " + getWeek;
    },
    clear() {
      clearInterval(this.nowTimes);
      this.nowTimes = null;
    }
  },
  mounted() {
    // this.startListening(); // 开始监听数据  新消息通知
    this.nowTimes();
    var user = sessionStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      // this.sysUserName = user.name || '';
      // this.sysUserAvatar = user.avatar || '';
    }
  }
};
</script>

<style scoped lang="scss">
.LayoutDio {
  /deep/ .el-dialog {
    position: fixed !important;
    right: 20px !important;
    bottom: 10px !important;
  }
}
.el-header {
  background: var(--header-bg);
  color: var(--header-text);
  // height: 80px !important;
}

.el-footer {
  background-color: #eee;
}

.el-aside {
  background: var(--sidebar-bg);
  color: var(--sidebar-text);
  // margin-top: 20px !important;
}

.el-main {
  /* 2026 定版：el-main 作全站渐变画布 + 统一 20px gutter；高度只减顶栏 60px */
  background: var(--app-bg);
  color: var(--text-sub);
  padding: 20px !important;
  height: calc(100vh - 60px);
}
/* 内容包裹层透明，透出 el-main 渐变（否则 bg-e2e2e2 的 --app-bg-solid 会盖住）*/
.el-main .bg-e2e2e2 {
  background: transparent !important;
}

.tools {
  height: 60px;
  line-height: 70px;
  cursor: pointer;
  .el-icon-s-fold,
  .el-icon-s-unfold {
    font-size: 25px;
  }
}
</style>
<style lang="scss">
.menu {
  height: calc(100vh - 60px);
  overflow: hidden;
  overflow-y: auto;
  background: var(--sidebar-bg);
}

.menu-collapsed {
  flex: 0 0 60px;
  width: 60px;
}
.menu-collapsed span {
  display: none;
}
.menu-expanded {
  flex: 0 0 200px;
  width: 200px;
}
.menu-expanded span {
  display: inline-block;
}
.menu .el-menu {
  background: var(--sidebar-bg);
  border-right: 0px;
}
/* 菜单项文字：!important 覆盖 el-menu 的 text-color="#fff" 内联 prop（白天白侧栏需可见）*/
.menu .el-menu .el-menu-item,
.menu .el-menu .el-submenu__title,
.menu .el-menu .el-menu-item span,
.menu .el-menu .el-submenu__title span,
.menu .el-menu .el-menu-item i,
.menu .el-menu .el-submenu__title i {
  color: var(--sidebar-text) !important;
}
.el-menu--vertical .el-menu-item {
  color: var(--sidebar-text) !important;
}
.el-menu--vertical .el-menu-item.is-active {
  color: var(--sidebar-active-text) !important;
}
.menu .el-menu .el-menu-item.is-active {
  background: var(--sidebar-active-bg);
  box-shadow: inset 3px 0 0 var(--accent);
}
/* hover 高亮（background 简写——该变量夜间为渐变，background-color 会整条失效）*/
.menu .el-menu .el-menu-item:hover,
.menu .el-menu .el-menu-item:focus {
  background: var(--sidebar-active-bg);
}
.menu .el-menu .el-menu-item.is-active span,
.menu .el-menu .el-menu-item:focus span,
.menu .el-menu .el-menu-item:hover span,
.menu .el-menu .el-menu-item.is-active i,
.menu .el-menu .el-menu-item:focus i,
.menu .el-menu .el-menu-item:hover i {
  color: var(--sidebar-active-text) !important;
}
.menu .el-menu .el-submenu__title:hover {
  background: var(--sidebar-active-bg);
}
.menu .el-menu .el-submenu__title:hover span,
.menu .el-menu .el-submenu__title:hover i {
  color: var(--sidebar-active-text) !important;
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: var(--header-bg);
}
.tupian {
  color: var(--header-text);
}
</style>
